import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-team.png'


const _withScopeId = n => (_pushScopeId("data-v-f73f6354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-team-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -wide -top-and-bottom" }
const _hoisted_3 = { class: "season-team-detail-content" }
const _hoisted_4 = { class: "return" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 戻る ")
const _hoisted_6 = { class: "team-detail-body" }
const _hoisted_7 = { class: "team-detail-main-block" }
const _hoisted_8 = {
  key: 0,
  class: "team-detail-header"
}
const _hoisted_9 = { class: "category" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "チーム情報を見る", -1))
const _hoisted_13 = {
  key: 1,
  class: "schedule-table"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "日程"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "会場"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "対戦チーム"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "本部"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "審判"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "schedule-table-th",
      width: "88"
    })
  ])
], -1))
const _hoisted_15 = { class: "division" }
const _hoisted_16 = { class: "division" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("詳細")
const _hoisted_18 = {
  key: 2,
  class: "global-empty-text"
}
const _hoisted_19 = { class: "global-loading" }
const _hoisted_20 = { class: "team-detail-side-block" }
const _hoisted_21 = { class: "entry-player-block" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry-player-heading" }, "登録選手", -1))
const _hoisted_23 = { class: "entry-player-list" }
const _hoisted_24 = { class: "number" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("登録選手を編集")
const _hoisted_26 = {
  key: 1,
  class: "empty-block"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "attention" }, [
  /*#__PURE__*/_createTextVNode("登録された選手が"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ここに表示されます")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "選手を大会に登録", -1))
const _hoisted_30 = { class: "global-loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "global-return-link",
            to: {
              name: 'seasonDetailHome',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id } }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.entry.data != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: "categoryIcon",
                      style: _normalizeStyle({ 'background-color': _ctx.entry.data.category_color })
                    }, null, 4),
                    _createElementVNode("span", {
                      class: "categoryText",
                      style: _normalizeStyle({ color: _ctx.entry.data.category_color })
                    }, _toDisplayString(_ctx.entry.data.category_name), 5)
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.entry.data.team_name) + " " + _toDisplayString(_ctx.entry.data.division), 1),
                  _createVNode(_component_router_link, {
                    to: {
                  name: 'teamDetail',
                  params: { team_id: parseInt(_ctx.entry.data.team_id) } },
                    class: "team-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.games.list.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games.list, (game) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: game.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(game.match_no), 1),
                        _createElementVNode("td", null, _toDisplayString(game.date), 1),
                        _createElementVNode("td", null, _toDisplayString(game.field_name), 1),
                        _createElementVNode("td", null, [
                          (game.home.team_id !== _ctx.entry.data.team_id)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {
                        name: 'seasonEntryDetail',
                        params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, team_id: parseInt(game.home.id) } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(game.home.team_name) + " ", 1),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(game.home.division), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: {
                        name: 'seasonEntryDetail',
                        params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, team_id: parseInt(game.away.id) } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(game.away.team_name) + " ", 1),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(game.away.division), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(game.official), 1),
                        _createElementVNode("td", null, _toDisplayString(game.refree), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'seasonGameDetail',
                        params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: parseInt(game.id) },
                        query: { group: parseInt(game.group_id) } },
                            class: "schedule-detail-button"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (!_ctx.games.isLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, "登録されている試合がありません"))
                : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
              [_vShow, _ctx.games.isLoading]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              (_ctx.rosters.list.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("ul", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rosters.list, (roster) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: roster.id,
                          class: "item"
                        }, [
                          _createVNode(_component_router_link, {
                            to: { name: 'playerDetail', params: { player_id: roster.player_id } },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(roster.number), 1),
                              _createTextVNode(" " + _toDisplayString(roster.player_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_router_link, {
                      to: { name: 'seasonEntryRoster', params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, team_id: _ctx.$route.params.team_id } },
                      class: "entry-player-button"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ], 64))
                : (!_ctx.rosters.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_router_link, {
                        to: { name: 'seasonEntryRoster', params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, team_id: _ctx.$route.params.team_id } },
                        class: "empty-add-button"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [
                [_vShow, _ctx.rosters.isLoading]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}